import React from "react";
import { Button as MuiButton, keyframes } from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";

export const Button = ({ variant = "contained", disabled, color, loading, children, sx, onClick }) => {
  const spin = keyframes`
    0% {
      transform:  rotate(0deg) 
    } 
    100% {
     transform: rotate(360deg)  
    } 
  `;

  return (
    <MuiButton
      onClick={onClick}
      variant={variant}
      disabled={disabled || loading}
      color={color}
      disableElevation
      sx={{
        minWidth: "7.5rem",
        ...sx,
      }}
      startIcon={
        loading && (
          <AutorenewIcon
            color="inherit"
            sx={{
              animation: `${spin} 1s linear infinite`,
            }}
          />
        )
      }
    >
      {children}
    </MuiButton>
  );
};
